import React, { useEffect, useRef, useState } from 'react';
import { BodyLoading, ColorLayerAbove, ContainerLoading, WrapperMessageContent } from './styled.jsx';
import loading from './../../assets/loadingIcon.svg';
import { STATUS_PROGRESS_LOADING } from '../../constants/status';
import PropTypes from "prop-types";
import { useTheme } from '@emotion/react';

const DEFAULT_BACKGROUND_COLOR = '#F3F3F3';

export const WrapperProgress = ({ active = true, progress = STATUS_PROGRESS_LOADING.NONE,
                                  messages = null, afterFinish = null, index = 99999,
                                  background = null, timeBackgroundRun = 2000, timeNextMessage = 3000 }) => {
  const refData = useRef();
  const theme = useTheme();
  const backgroundColor = background || theme?.palette?.background?.default || DEFAULT_BACKGROUND_COLOR;
  const [progressNumber, setProgressNumber] = useState(0);
  let [orderMessage, setOrderMessage] = useState(1);
  const [message, setMessage] = useState((messages && messages[0]) || '');

  const renderMessage = React.useCallback(
    (index) => {
      const length = messages.length;
      if (index < length) return setMessage(messages[index]);
      return setMessage(messages[length - 1]);
    },
    [messages],
  );

  useEffect(() => {
    if (progress === STATUS_PROGRESS_LOADING.START && messages) {
      refData.current = setInterval(() => {
        renderMessage(orderMessage);
        setOrderMessage((order) => order++);
      }, timeNextMessage);
    }
    if (progress === STATUS_PROGRESS_LOADING.FINISH) {
      setProgressNumber(100);
    }
    return () => window.clearInterval(refData.current);
  }, [progress, timeNextMessage, messages, orderMessage, renderMessage]);

  useEffect(() => {
    progressNumber === 100 && setTimeout(() => afterFinish(), timeBackgroundRun + 250);

  }, [progressNumber, timeBackgroundRun, afterFinish]);

  if (progress === STATUS_PROGRESS_LOADING.FINISH) {
    window.clearInterval(refData.current);
  }
  return (
    <BodyLoading config={{ index: index }}>
      <ContainerLoading>
        <WrapperMessageContent className={`hide ${active ? 'show-in' : 'show-out'}`}>
          <img src={loading} alt={loading} />
          <div className="title">{message}</div>
        </WrapperMessageContent>
        <ColorLayerAbove
          animation={{
            speed: timeBackgroundRun,
          }}
          style={{
            height: progressNumber + 'vh',
            background: backgroundColor,
          }}
        />
      </ContainerLoading>
    </BodyLoading>
  );
};

WrapperProgress.propTypes = {
  active: PropTypes.bool,
  progress: PropTypes.oneOf([STATUS_PROGRESS_LOADING.NONE,
    STATUS_PROGRESS_LOADING.START, STATUS_PROGRESS_LOADING.FINISH]),
  messages: PropTypes.array,
  afterFinish: PropTypes.func,
  index: PropTypes.number,
  background: PropTypes.object,
  timeBackgroundRun: PropTypes.number,
  timeNextMessage: PropTypes.number,
};
